import React from "react";
import ComingSoon from "../Common/ComingSoon.jsx";

const KnowledgeHubPage = () => <ComingSoon />;

export default KnowledgeHubPage;

